import { createContext, useContext } from '@berlin-front/common/composables/context';
import type { ContextValueType } from '@berlin-front/common/composables/context';
import { reactive, computed } from '@vue/composition-api';
import { ApiCacheContext } from '@services/ApiCacheContext';
import { AtoneMemberTypePostResponseMemberTypeEnum } from '@netprotections/berlin-bff';
import { useRouter } from '@berlin-front/common/composables/useRouter';

import { ROUTE_NAME } from '@/router/route-name';

export const useIntro = () => {
  const apiCacheContext = useContext(ApiCacheContext);
  const router = useRouter();

  const memberType = computed(
    () =>
      apiCacheContext.atoneMemberTypePostResult.value?.memberType ?? AtoneMemberTypePostResponseMemberTypeEnum.NUMBER_0,
  );

  const SERVICE_URL = process.env.VUE_APP_NP_ATOBARAI_ATONE_SERVICE_URL;

  const atoneLoginClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.replace({ name: ROUTE_NAME.ATONE_LOGIN_ATONE });
  };
  const npLoginClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.replace({ name: ROUTE_NAME.ATONE_MEMBER_NP_LOGIN });
  };
  const registerClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.replace({ name: ROUTE_NAME.ATONE_MEMBER_REGISTER });
  };

  return reactive({
    // 連携パラメータ。
    memberType,

    // 関数。
    atoneLoginClick,
    npLoginClick,
    registerClick,

    // 定数値。
    SERVICE_URL,
  });
};

export const IntroContext = createContext({ useIntro });
export type IntroContextType = ContextValueType<typeof IntroContext>;
